import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fetchRelatedProperties } from '../../../helpers/connect_api';
import { Spinner, Table } from 'react-bootstrap-5';
import { formatWithCommas, USD } from '../../../../../helpers/formatters/number_formats';
import { setOffMarketPropertyId } from '../../search/helpers/navigation_helper';

export default function SimilarProperties({ insightsPropertyId }) {
  const [relatedProperties, setRelatedProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRelatedProperties(insightsPropertyId)
      .then(properties => setRelatedProperties(properties))
      .finally(() => setLoading(false));
  }, [insightsPropertyId]);

  if (loading) return (
    <div className="px-3 py-5">
      <div className="text-center">
        <Spinner animation="border" variant="primary" />
      </div>
    </div>
  );

  if (relatedProperties.length === 0) return <div>No similar properties found</div>;

  return (
    <Table responsive>
      <thead>
        <tr>
          <th>Address</th>
          <th>Type</th>
          <th>SF</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        {relatedProperties.map(prop => (
          <tr key={prop.propertyId}>
            <td>
              <span className="clickable text-primary" onClick={() => setOffMarketPropertyId(prop.propertyId)}>
                {prop.address}
              </span>
              <div>
                {prop.city}, {prop.state}
              </div>
            </td>
            <td>{prop.propertyType}</td>
            <td>{prop.buildingSizeSf && formatWithCommas(prop.buildingSizeSf)}</td>
            <td>{prop.lastSalePrice && USD.format(prop.lastSalePrice, { round: true })}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

SimilarProperties.propTypes = {
  insightsPropertyId: PropTypes.number
};
